module.exports = __webpack_public_path__ + "img/home2.902bd06a.jpg";